module.exports = __webpack_public_path__ + "static/media/Cheerleader.1547de46.jpg";